
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prohyp-2/register",
      function () {
        return require("private-next-pages/prohyp-2/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prohyp-2/register"])
      });
    }
  